import { addError } from '@mfe-helpers/datadog';
import decodeJWT from 'jwt-decode';

import { AuthResult } from './authenticate';
import { Authentication, getCookie } from './authHelpers';

type UseJwtResult = Authentication;

export function extractClaimsFromAccessToken(accessTokenCookieKey: string): UseJwtResult {
    const result: UseJwtResult = {
        error: undefined,
        accessToken: undefined,
        claims: undefined,
    };

    const cookieValue = getCookie(accessTokenCookieKey);
    if (cookieValue) {
        try {
            const decodedClaims = decodeJWT<AuthResult>(cookieValue);
            result.accessToken = cookieValue;
            result.claims = decodedClaims;
        } catch (error) {
            result.error = (error as Error).message;
            addError(error);
        }
    } else {
        result.error = `JWT cookie ${accessTokenCookieKey} not found!`;
    }

    return result;
}
